module.exports = __webpack_public_path__ + "cae79454c293074f1353a79a48ef78.png";